<template>
  <div>
    <div class="search-box">
      <el-input
        v-model="searchUsername"
        placeholder="请输入用户名搜索"
        clearable
        @input="handleSearch"
        style="width: 300px; margin-bottom: 20px;"
      />
    </div>
    <div id="container" />
    <el-pagination class="page"
      background
      layout="total, prev, pager, next"
      :page-count="total"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import { Chart } from '@antv/g2';
  import Global from "./Global";

  export default {
    name: "usetime",
    data() {
      return {
        total: 20,
        chart: null,
        searchUsername: '',
        currentPage: 1
      };
    },
    //这是一次尝试
    mounted() {
      this.chart = new Chart({
              container: 'container',
              autoFit: true,
              height: 680,
              padding: [0, 70],
            });
      this.initLineChart(1, this.chart)
    },
    methods: {
      handleSearch() {
        this.currentPage = 1;
        this.updateData(1, this.chart);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.updateData(val, this.chart);
      },
      initLineChart(pageNum, chart) {
        this.updateData(pageNum, chart);
      },
      updateChart(pageNum, chart) {
        chart.clear();
        this.updateData(pageNum, chart);
      },
      updateData(pageNum, chart) {
        let that = this;
        let url = Global.accountUrl + "/storkCollectData/selectAllUserUseTimeByPage?pageNum="+pageNum+"&pageSize=10";
        if (this.searchUsername) {
          url += "&username=" + encodeURIComponent(this.searchUsername);
        }
        fetch(url)
          .then(res => res.json())
          .then(data => {
            that.total = data.data.total;
            chart.data(data.data.data);
            chart.scale({
              value: {
                max: 100,
                min: 0,
                alias: '时间（分钟）',
              },
            });
            chart.axis('username', {
              title: null,
              tickLine: null,
              label: {
                formatter: (val) => {
                  let str = val + '';
                  return str.substring(0, 3) + '**' + str.substring(str.length - 4);
                }
              }
            });
            chart.axis('usetime', {
              label: null,
              title: {
                offset: 30,
                style: {
                  fontSize: 12,
                  fontWeight: 300,
                },
              },
            });
            chart.legend(false);
            chart.coordinate().transpose();
            chart.tooltip({
              itemTpl: `
                              <ul style="margin: 10px">
                                <li style = "padding: 10px 0">用户昵称：{nickname}</li>
                                <li>使用时长：{usetime}分钟</li>
                              </ul>
                             `,
            });
            chart
              .interval({
                sortable: true
              })
              .position('username*usetime')
              .size(26)
              .tooltip({
                fields: ['nickname', 'usetime'],
                callback: (nickname, usetime) => {
                  return {
                    nickname,
                    usetime
                  }
                }
              })
              .label('usetime',
                (xValue) => {
                  return {
                    content: xValue + '分钟',
                  };
                },
                {
                  type: 'base',
                }
              );
            chart.on('element:click', e => {
              let element = e.target.get("element");
              let data = element.getModel().data;
              that.toLocation(data.username);
            });
            chart.interaction('element-active');
            chart.render();
          });
      },
      toLocation(username) {
        this.$emit('getLocation', username);
      }
    }
  };
</script>

<style>
  .page {
    width: 400px;
    margin: 20px auto;
  }
  .search-box {
    margin: 20px auto;
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/UseTime.vue